/* eslint-disable no-restricted-globals */

import { Layout } from "antd";
import { AppContent } from "./components/templates/app-content/AppContent";
import { Header } from "./components/organisms/header/Header";
import { useEffect, useState } from "react";
import { useLocation, useMatch } from "react-router-dom";
import { useAppContext } from "./contexts/useAppContext";
import { Footer } from "./components/organisms/footer/Footer";
import { useFirebase } from "./hooks/useFirebase";
import { getCompanySlugByCustomDomain } from "./service";
import { isCustomDomain } from "./utils/navigation";
import { useAnalytics } from "./hooks/useAnalytics";
import { CookieConsent } from "./components/atoms/CookieConsent";

const { Content } = Layout;
const isCustomDomainMode = isCustomDomain();

function App() {
  useFirebase();
  const location = useLocation();
  const { setRestaurantSlug } = useAppContext();
  const [ready, setReady] = useState(false);

  const slugMatch = useMatch('/:restaurantSlug/*');
  const urlSlug = slugMatch?.params?.restaurantSlug ?? null;
  const isMenuPage = isCustomDomainMode
    ? location.pathname !== '/'
    : !!slugMatch?.params?.restaurantSlug;

  useAnalytics();

  // 1. On mount: fetch slug from API for custom domains
  useEffect(() => {
    if (!isCustomDomainMode) {
      setReady(true);
      return;
    }
    getCompanySlugByCustomDomain(window.location.hostname).then((result) => {
      if (result?.slug) setRestaurantSlug(result.slug);
      setReady(true);
    });
  }, [setRestaurantSlug]);

  // 2. Routing logic: sync slug from URL to context
  useEffect(() => {
    if (!ready) return;

    if (!isCustomDomainMode && urlSlug) {
      setRestaurantSlug(urlSlug);
    }
  }, [ready, urlSlug, setRestaurantSlug]);

  // Ordering status is now shown via sticky OnlineOrderingBanner in MenuFlowPage.

  if (!ready) return null;

  return (
    <Layout style={{ minHeight: "100vh", background: "var(--color-surface)" }}>
      <Header />
      <Content>
        <AppContent />
      </Content>
      {isMenuPage && <Footer />}
      {/* <InstallPWA /> */}
      <CookieConsent />
    </Layout>
  );
}
export default App;
